"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("@emotion/react/jsx-runtime");
const useMediaQuery_1 = __importDefault(require("@mui/material/useMediaQuery"));
const Stack_1 = __importDefault(require("@mui/material/Stack"));
const Skeleton_1 = __importDefault(require("@mui/material/Skeleton"));
function default_1() {
    const fakeArr = Array(14).fill(0);
    const maxWidth768 = (0, useMediaQuery_1.default)('(max-width:768px)');
    return ((0, jsx_runtime_1.jsx)("div", Object.assign({ css: {
            display: 'grid',
            gridTemplate: 'repeat(2, 80px) / repeat(7, 1fr)',
            padding: maxWidth768 ? '8px 0 7px' : 0,
            overflow: 'hidden',
        } }, { children: fakeArr.map((_, index) => {
            return ((0, jsx_runtime_1.jsxs)(Stack_1.default, Object.assign({ sx: {
                    rowGap: '4px',
                    alignItems: 'center',
                    minWidth: maxWidth768 ? '72px' : 'unset',
                    padding: '0 4px 8px',
                    '> *': { flexShrink: 0 },
                } }, { children: [(0, jsx_runtime_1.jsx)(Skeleton_1.default, { animation: "wave", variant: "rectangular", sx: {
                            width: '100%',
                            height: '100%',
                            maxWidth: '40px',
                            maxHeight: '40px',
                            borderRadius: '8px',
                            margin: '8px',
                        } }), (0, jsx_runtime_1.jsx)(Skeleton_1.default, { animation: "wave", variant: "rectangular", sx: { width: '75%', height: '13px', margin: '3px 0 4px', borderRadius: '2px' } })] }), `main_fond_skeleton_${index}`));
        }) })));
}
exports.default = default_1;
